var map = {
	"./icon-bonus.png": 20919,
	"./icon-firend.png": 25011,
	"./icon-gift-small.png": 34664,
	"./icon-gift.png": 82043,
	"./icon-lock-small.png": 69220,
	"./icon-rank.png": 50115,
	"./icon-stock.png": 41174,
	"./icon-upgrade.png": 98094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29273;